import React, { useEffect, useState } from "react";
import ListItem from "../../component/ListItem";
import { useParams } from "react-router-dom";
import Tabs from "../../component/Tabs";
import { useDispatch, useSelector } from "react-redux";
import { fetchMenuData } from "../../redux/action";
import ItemStatus from "../../component/MenuCard/ItemStatus";
import EmptyScreen from "../../component/common/EmptyScreen";

import AvailabilitySchedule from "../../component/MenuCard/AvailabilitySchedule";

const MenuStatus = () => {
    const { restaurantId, locationId } = useParams();
    const [selectedTabId, setSelectedTab] = useState('');
    const [search, setSearch] = useState("");

    const dispatch = useDispatch();
    const menuList = useSelector((state) => state?.user?.menu) || {};

    useEffect(() => {
        dispatch(fetchMenuData());
    }, [dispatch]);

    // Automatically select the 1st category ID once menuList loads
    useEffect(() => {
        if (menuList?.categories?.length > 0 && !selectedTabId) {
            setSelectedTab(menuList.categories[0].categoryId);
        }
    }, [menuList, selectedTabId]);

    const tabList = () => {
        const categories = menuList?.categories || [];
        return categories.map((val) => ({
            categoryId: val.categoryId,
            category: val.categoryName,
            isSelected: val.categoryId === selectedTabId,
        }));
    };

    const selectedItems = () => {
        if (!menuList?.categories) return null;

        // 1. Find active category or default to the first category with items
        const activeCategory = menuList.categories.find(
            (cat) => cat.categoryId === selectedTabId
        ) || menuList.categories.find(
            (cat) => Array.isArray(cat.items) && cat.items.length > 0
        );

        if (!activeCategory) return null;

        // 2. Filter items checking both 'name' and 'foodName' properties safely
        const filteredItems = (activeCategory.items || []).filter((food) => {
            const itemName = food?.name || food?.foodName || '';
            return itemName.toLowerCase().includes(search.trim().toLowerCase());
        });

        return {
            ...activeCategory,
            items: filteredItems
        };
    };

    return (
        <div className="cart-container">
            <div className="lrSpace">
                <h2>Update availability of menu item</h2>
                {menuList.categories ? (
                    <>
                        <Tabs tabs={tabList()} tabSelect={setSelectedTab} />
                        <input 
                            type="text" 
                            placeholder="Search items in selected category..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="search-input" 
                        />
                        {selectedItems() && selectedItems().categoryId !== "f0000010-3d4b-4b72-84cd-300000000001" && (
                          <AvailabilitySchedule key={selectedItems().categoryId} categoryId={selectedItems().categoryId} name={selectedItems().categoryName} schedule={selectedItems().availabilitySchedule} />
                        )}
                        <ListItem category={selectedItems()} ActionComponent={ItemStatus} />
                    </>
                ) : (
                    <EmptyScreen message="No menu found for this restaurant. Please add categories and items." />
                )}
            </div>
        </div>
    );
};

export default MenuStatus;